<template>
  <div class="app">
    <router-view></router-view>
    <confirm-modal/>
    <notifications/>
    <scroll-to-top/>
  </div>
</template>

<script>
import { ConfirmModal } from "@/components/confirm";
import { Notifications } from "@/components/notifications";
import { ScrollToTop } from "@/components/common";
import { captureException } from "@sentry/browser";

export default {
  name: "App",
  components: {
    ConfirmModal,
    Notifications,
    ScrollToTop
  },
  errorCaptured(err) {
    captureException(err);
    throw err;
  }
}
</script>
